import { CollapseType } from '@meitu/saas-editor-ui/es/types';
import { events } from '@/events-bus';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { isIntl, REACT_APP_ENV } from '@/react-process-env';
import { useStoreActions, useStoreState } from '@/store';
import thumbnailOfEffectText from '../../assets/effect-text-thumbnail.png';
import thumbnailOfShapeTextDark from '../../assets/shape-text-dark-thumbnail.png';
import thumbnailOfShapeTextLight from '../../assets/shape-text-light-thumbnail.png';
import { BlockContainer } from '../../components';
import { Funcs, ScopeEvents } from '../../constants';
import { Tracker } from '../../utils';
import './style.less';

const TextShortcut: React.FC = () => {
    const { $t } = useLocaleStore();

    const theme = useStoreState((state) => state.editorModel.theme);
    const setCurrentType = useStoreActions((actions) => actions.collapseModel.setCurrentType);
    const recordInfo = useStoreState((state) => state.recordModel.recordInfo);

    const openTextCollapse = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.OpenTextPanel);

        Tracker.openTextMaterialCollapse(recordInfo?.id);

        setCurrentType(CollapseType.TEXT_MENU);
    };

    const addByDefaultTitle = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.AddTextLayer);
        Tracker.addTextLayerByPreset();
        editor.textLayer.addByDefaultTitle();
    };

    const addByDefaultSubTitle = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.AddTextLayer);
        Tracker.addTextLayerByPreset();
        editor.textLayer.addByDefaultSubTitle();
    };

    const addByDefaultContent = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.AddTextLayer);
        Tracker.addTextLayerByPreset();
        editor.textLayer.addByDefaultContent();
    };

    const addByDefaultShapeText = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.AddTextLayer);
        Tracker.addTextLayerByPreset();

        const materialID =
            REACT_APP_ENV === 'beta' || REACT_APP_ENV === 'release' ? '1701150781645501' : '1699523891681574';

        editor.textLayer.addByDefaultShapeText(materialID);
    };

    const addByDefaultEffectText = () => {
        events.emit(ScopeEvents.FuncUse, Funcs.AddTextLayer);
        Tracker.addTextLayerByPreset();
        editor.textLayer.addByDefaultEffectText();
    };

    return (
        <BlockContainer className="text-shortcut" title={$t((v) => v.collapse.shortcutCollapse.text.menuTitle)}>
            <div className="text-shortcut__btns">
                <div className="shortcut-btn text-shortcut__btn text-shortcut__btn--title" onClick={addByDefaultTitle}>
                    {$t((v) => v.collapse.shortcutCollapse.text.title)}
                </div>
                <div
                    className="shortcut-btn text-shortcut__btn text-shortcut__btn--subTitle"
                    onClick={addByDefaultSubTitle}
                >
                    {$t((v) => v.collapse.shortcutCollapse.text.subTitle)}
                </div>
                <div
                    className="shortcut-btn text-shortcut__btn text-shortcut__btn--content"
                    onClick={addByDefaultContent}
                >
                    {$t((v) => v.collapse.shortcutCollapse.text.text)}
                </div>
            </div>

            {!isIntl ? (
                <div className="text-shortcut__btns">
                    <div
                        className="shortcut-btn text-shortcut__btn text-shortcut__btn--complex"
                        onClick={addByDefaultShapeText}
                    >
                        <img
                            draggable={false}
                            src={theme === 'light' ? thumbnailOfShapeTextLight : thumbnailOfShapeTextDark}
                            alt=""
                        />
                    </div>

                    <div
                        className="shortcut-btn text-shortcut__btn text-shortcut__btn--complex"
                        onClick={addByDefaultEffectText}
                    >
                        <img draggable={false} src={thumbnailOfEffectText} alt="" />
                    </div>
                </div>
            ) : null}
        </BlockContainer>
    );
};

export default TextShortcut;
